// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1___79d389e5ed51d6a97a7","cls2":"AuthorHeader-cls2___d99d356e1bfe0d77386 AuthorHeader-cls1___79d389e5ed51d6a97a7"};